import styled from 'styled-components';
import _find from 'lodash.find';

const StaticValue = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

const EditableValue = styled(StaticValue)<{ isUpdated: boolean }>`
  i {
    font-size: 14px;
    color: ${({ theme, isUpdated }) => (isUpdated ? theme.colors.attention : theme.colors.brand_blue)};
  }

  &:hover {
    cursor: pointer;
    color: ${({ theme, isUpdated }) => (isUpdated ? theme.colors.attention : theme.colors.brand_blue)};
  }
`;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 6px;
  align-items: center;

  i.cellChangeInfo {
    font-size: 12px;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.brand_blue};
  }
`;

const ValueUpdateInfo = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 16px;
  row-gap: 4px;

  p {
    font-weight: bold;
    grid-column: span 2;
    margin-bottom: 8px;
  }

  span:nth-child(even) {
    font-weight: bold;
  }
`;

const TableWrapper = styled.div`
  margin-bottom: 16px;

  .p-component {
    font-size: 0.857rem !important;
  }

  .p-treetable .p-treetable-tbody > tr {
    vertical-align: top;
  }

  .p-treetable .p-treetable-tbody > tr > td {
    padding: 8px;
  }
`;

const ActionsPanel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  align-items: flex-start;
  gap: 32px;
  margin-bottom: 16px;
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 32px;  

  label {
    display: block;
    font-size: 0.75rem;
    font-weight: bold;
    margin-bottom: 6px;
  }

  .p-button-label {
    font-size: 0.75rem;
  }
`;

const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
`;

const SummaryWrapper = styled.div`
  margin: 32px 0;
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 50px;
  row-gap: 16px;

  & > div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 8px;
  }
`;

const TargetTotalWrapper = styled.div`
  margin: 32px 0;
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 50px;
  row-gap: 16px;

  & > div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 8px;
  }
`;

const SummaryLabel = styled.span`
  display: inline-block;
  font-weight: 700;
  color: #343a40;
`;

 const ColumnsSelectorWrapper = styled.div`
  margin-bottom: 10px;
  width: 100%;
  text-align: right;
`;


const getReasonStrById = (id: number, reasonsData: any[]) => {
  const reason = _find(reasonsData, (item: any) => item.id === id);
  return reason ? reason.description : '-';
};

const CONSUMPTION_VIEW_HIDDEN_COLUMNS_KEY = 'ConsumptionViewHiddenColumns';

export {
  getReasonStrById,
  StaticValue,
  EditableValue,
  ValueWrapper,
  ValueUpdateInfo,
  TableWrapper,
  ActionsPanel,
  FilterWrapper,
  Filters,
  BtnsWrapper,
  SummaryWrapper,
  SummaryLabel,
  TargetTotalWrapper,
  ColumnsSelectorWrapper,
  CONSUMPTION_VIEW_HIDDEN_COLUMNS_KEY,
};
